<template>
  <a-upload name="file" :customRequest='uploadFn' list-type="picture-card" class="avatar-uploader"
    :show-upload-list="false" :before-upload="beforeUpload" @change="handleChange">
    <img class="upImg" :width='width' :height='height' v-if="imageUrl" :src="imageUrl" alt="file" />
    <div class="up_icon" v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
    <!-- <span class="loding"><a-progress :percent="50" :show-info="false" /></span> -->
  </a-upload>
</template>

<script>
import { uploadFn } from "@/api/upload";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  props: {
    image: { type: String, default: "" },
    width: { type: String, default: "60px" },
    height: { type: String, default: "60px" },
  },
  data() {
    return {
      loading: false,
      imageUrl: "",
      file: {},
    };
  },
  created() {
    this.imageUrl = this.image;
    console.log(this.image);
  },
  methods: {
    handleChange(info) {
      this.file = info;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("仅支持jpeg或png图片！");
      }
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$message.error("图片大小不超过8M！");
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadFn(data) {
      let str = await uploadFn({ file: data.file });
      this.file.file.status = "done";
      this.handleChange(this.file);
      this.$emit("uploadOk", str);
    },
  },
};
</script>

<style>
.avatar-uploader {
  width: 100%;
  height: 100%;
  position: relative;
}
.loding{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
.avatar-uploader > .ant-upload {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.up_icon {
  font-size: 12px;
}
</style>